import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { G_GRAPH__DRAG_AND_DROP__image_external } from '../_base/_drag_and_drop/G_GRAPH__DRAG_AND_DROP__image_external';
import { G_GRAPH__DRAG_AND_DROP__image_internal } from '../_base/_drag_and_drop/G_GRAPH__DRAG_AND_DROP__image_internal';
import { G_IMAGE__master_component } from '../_views/G_IMAGE__master_component';
import { G_BAR__image_asset_actions_left } from './G_BAR__image_asset_actions_left';
import { G_BAR__image_asset_actions_right } from './G_BAR__image_asset_actions_right';

const { GRID_CELL_SIZE, GRAPH_FIELD_HEIGHT_IMAGE } = CONSTANTS__shared;

interface PROPS {
  field: FIELD__image_asset;
}

export function G_GRAPH__FIELD__image_asset({ field }: PROPS) {
  let IMAGE_AREA_HEIGHT = GRID_CELL_SIZE * GRAPH_FIELD_HEIGHT_IMAGE;

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <div className="flex flex-row w-full relative" style={{ height: `${IMAGE_AREA_HEIGHT}px` }}>
      <G_BAR__image_asset_actions_left {...{ field }} />

      <div className=" flex-1 flex-center overflow-hidden" style={{ height: `${IMAGE_AREA_HEIGHT}px` }}>
        <G_IMAGE__master_component {...{ field }}></G_IMAGE__master_component>

        <G_GRAPH__DRAG_AND_DROP__image_external {...{ field }} />
        <G_GRAPH__DRAG_AND_DROP__image_internal {...{ field }} />
      </div>

      <G_BAR__image_asset_actions_right {...{ field }} />
    </div>
  );
}
